// import { axiosInstance } from '../../network/apis';
// const handlerEnabled = false;

export const getTheme = async () => {
  return { data: {} };
  // return await axiosInstance.get(`launches`, { handlerEnabled });
};
